"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _compositionsButtonWithIcon = _interopRequireDefault(require("@eig-builder/compositions-button-with-icon"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _constants = require("./../constants");

var PostReplyButton = function PostReplyButton(_ref) {
  var fireCallBack = _ref.fireCallBack;
  return /*#__PURE__*/_react["default"].createElement(_compositionsButtonWithIcon["default"], {
    onClick: function onClick() {
      return fireCallBack(_constants.CALLBACK_ACTIONS.POST_REPLY);
    },
    color: "primary",
    size: "medium",
    icon: /*#__PURE__*/_react["default"].createElement("i", {
      className: "material-icons"
    }, "reply"),
    labelPosition: "after",
    tag: "post-reply",
    dataElementLocation: _taggingHelper.DataElementLocations.HEADER,
    dataElementId: "gmb-review-reply-post-reply-cta",
    dataElementLabel: "gmb.review.reply"
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "helpers.gmbWithCustomFocusNavigation.postReply"
  }));
};

PostReplyButton.propTypes = {
  fireCallBack: _propTypes["default"].func.isRequired
};
var _default = PostReplyButton;
exports["default"] = _default;